import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function Invoice() {
  const { orderRef } = useParams();

  useEffect(() => {
    // Redirect to backend invoice endpoint
    window.location.href = `${API_URL}/api/invoice/${orderRef}`;
  }, [orderRef]);

  return (
    <div className="min-h-screen pt-24 flex items-center justify-center">
      <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full" />
    </div>
  );
}
